import useSWR from 'swr';

export const useCompany = (id) => {
  const { data, error, isLoading, mutate } = useSWR(`/companies/${id}`);

  return {
    data,
    error,
    isLoading,
    mutate,
  };
};
